// Utilidades numéricas del mundo. El movimiento de cámara usa resortes críticamente
// amortiguados: aceleran y frenan con suavidad, nunca de forma lineal, y se pueden
// interrumpir en cualquier momento sin saltos (la velocidad se conserva).

export const clamp = (v: number, a = 0, b = 1) => Math.min(b, Math.max(a, v));
export const lerp = (a: number, b: number, t: number) => a + (b - a) * t;
export const smoothstep = (a: number, b: number, v: number) => {
  const t = clamp((v - a) / (b - a));
  return t * t * (3 - 2 * t);
};
// Rampa suave de orden 5 (derivada segunda nula en los extremos): para cámaras.
export const smootherstep = (a: number, b: number, v: number) => {
  const t = clamp((v - a) / (b - a));
  return t * t * t * (t * (t * 6 - 15) + 10);
};

/** Resorte crítico 1D (Ryan Juckett / "SmoothDamp"). Estado mutable para no generar basura. */
export type Spring = { value: number; velocity: number };

export function springStep(s: Spring, target: number, smoothTime: number, dt: number, maxSpeed = Infinity) {
  const omega = 2 / Math.max(1e-4, smoothTime);
  const x = omega * dt;
  const exp = 1 / (1 + x + 0.48 * x * x + 0.235 * x * x * x);
  let change = s.value - target;
  const maxChange = maxSpeed * smoothTime;
  change = clamp(change, -maxChange, maxChange);
  const t = s.value - change;
  const temp = (s.velocity + omega * change) * dt;
  s.velocity = (s.velocity - omega * temp) * exp;
  let out = t + (change + temp) * exp;
  // Evita pasarse del objetivo.
  if (target - s.value > 0 === out > target) {
    out = target;
    s.velocity = (out - target) / Math.max(dt, 1e-6);
  }
  s.value = out;
  return out;
}

/** Amortiguación exponencial independiente de los cuadros por segundo. */
export const damp = (current: number, target: number, lambda: number, dt: number) =>
  lerp(current, target, 1 - Math.exp(-lambda * dt));

/** PRNG determinista (mulberry32): la ciudad sale igual en cada visita y en cada equipo. */
export function rng(seed: number) {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
